// extracted by mini-css-extract-plugin
export default {"InlineEditor":"InlineEditor--RAI2f"};